export default "__VITE_ASSET__82faaa7f__"